import api from "../../api/v1";

const state_ = () => ({
    items: false,
    pages: false,
    meta: false,
    current: false,
    currentId: false,
    item: false,
});


const getters_ = {
    pages(state) {
        return state.pages
    },
    meta(state) {
        return state.meta
    },
    item(state) {
        return state.item
    },
    items(state) {
        return state.items
    },
    currentId(state) {
        return state.currentId
    },
    current(state) {
        return state.current
    },
}

const actions_ = {
    async get_count(ctx, data = {}) {
        data.get_count = 'Y'
        let result = await this.$api.orders.list(data)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        return answer
    },
    async list({commit}, data) {
        let result = await this.$api.orders.list(data)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        commit('setItems', answer)
        commit('setPages', result.meta.links)
        commit('setMeta', result.meta)
        return answer
    },
    async detail({commit}, data) {
        let result = await this.$api.orders.detail(data.id, data)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        // answer.comment = 'setItem';
        commit('setItem', answer)
        return answer
    },
    async add(fields, data) {
        fields = JSON.parse(JSON.stringify(data));
        fields.json_data = JSON.stringify(fields.json_data);
        let result = await this.$api.orders.add(fields)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        return answer
    },
    async update({dispatch}, data) {
        if (data.id == 'add') {
            return await dispatch('add', data)
        }
        var fields = JSON.parse(JSON.stringify(data));
        fields.json_data = JSON.stringify(fields.json_data);
        let result = await this.$api.orders.update(fields.id, fields)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        return answer
    },

    deliveryAddressUpdate({commit}, data) {
        return api.order.deliveryAddressUpdate(data).then(
            response => {
                commit ('updateAddress', response)
                return Promise.resolve(response)
            },
            error => Promise.reject(error)
        )
    }
};

const mutations_ = {
    setItem(state, item) {
        state.item = item;
    },
    setItems(state, items) {
        state.items = items;
    },
    setPages(state, data) {
        var pages = data;
        var links = {
            prev: pages.shift(),
            next: pages.pop(),
        };
        state.pages = {
            items: pages,
            links: links,
        }
    },
    setMeta(state, data) {
        state.meta = data
    },
    updateAddress(state, data) {
       state.item.address = data
    }
};
export const actions = actions_;
export const state = state_;
export const mutations = mutations_;
export const getters = getters_;
